import { Injectable } from '@angular/core';

/**
 * Service to provide environment-specific configuration.
 * Determines gateway URLs and other environment settings dynamically.
 */
@Injectable({
  providedIn: 'root'
})
export class EnvConfigService {
  private gatewayUrl: string = null;

  constructor() {}

  /**
   * Gets the gateway URL based on the current environment.
   * Similar to the crew-jumpseat-ui pattern.
   */
  getGatewayUrl(): string {
    if (!this.gatewayUrl) {
      const origin = window.location.origin;
      
      if (origin.includes('localhost')) {
        // Local development - use relative path for proxy to intercept
        this.gatewayUrl = '/crew-cvv-gateway';
      } else {
        // Production/Deployed - construct gateway URL
        // Pattern: replace 'cvv' with 'crew-cvv-gateway' in the URL
        this.gatewayUrl = origin.replace('cvv', 'crew-cvv-gateway');
      }
    }
    
    return this.gatewayUrl;
  }

  /**
   * Gets the base API URL for CVV service calls.
   */
  getApiBaseUrl(): string {
    return this.getGatewayUrl() + '/crew-cvv-service/api/v1';
  }

  /**
   * Checks if the app is running in a local development environment.
   */
  isLocalEnvironment(): boolean {
    return window.location.hostname === 'localhost';
  }

  /**
   * Checks if the app is running in production.
   */
  isProductionEnvironment(): boolean {
    return window.location.hostname.includes('ups.com');
  }

  /**
   * Gets the current environment name.
   */
  getEnvironmentName(): string {
    const hostname = window.location.hostname;
    
    if (hostname === 'localhost') {
      return 'LOCAL';
    }
    if (hostname.includes('ups.com')) {
      return 'PROD';
    }
    if (hostname.includes('ams1907.com')) {
      return 'DEV';
    }
    return 'OPENSHIFT';
  }
}
